import { z } from "zod";
export const DesignSelectionV1Schema = z
    .object({
    schemaVersion: z.literal("design-selection.v1.0"),
    certifiedLookId: z.string().min(1),
    componentVariants: z.array(z.object({ role: z.string().min(1), variantId: z.string().min(1) }).strict()),
    selectedAt: z.string().datetime(),
})
    .strict();
export const CertifiedLookV1Schema = z
    .object({
    schemaVersion: z.literal("certified-look.v1.0"),
    lookId: z.string().min(1),
    displayName: z.string().min(1),
    certified: z.literal(true),
    accessibilityChecked: z.boolean(),
    mobileChecked: z.boolean(),
})
    .strict();
export const ComponentVariantV1Schema = z
    .object({
    schemaVersion: z.literal("component-variant.v1.0"),
    variantId: z.string().min(1),
    role: z.string().min(1),
    certified: z.boolean(),
})
    .strict();
export const DesignCompatibilityMatrixV1Schema = z
    .object({
    schemaVersion: z.literal("design-compatibility-matrix.v1.0"),
    lookId: z.string().min(1),
    compatibleVariants: z.array(z.string()),
    incompatibleVariants: z.array(z.string()).default([]),
})
    .strict();
export const DesignVariantPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("design-variant-policy.v1.0"),
    policyVersion: z.string().min(1),
    allowUncertifiedVariants: z.literal(false),
    allowRawCssInjection: z.literal(false),
    allowRawJsInjection: z.literal(false),
})
    .strict();
export const VisualRegressionSnapshotV1Schema = z
    .object({
    schemaVersion: z.literal("visual-regression-snapshot.v1.0"),
    lookId: z.string().min(1),
    snapshotHash: z.string().min(1),
    capturedAt: z.string().datetime(),
})
    .strict();
export const DEFAULT_DESIGN_VARIANT_POLICY = DesignVariantPolicyV1Schema.parse({
    schemaVersion: "design-variant-policy.v1.0",
    policyVersion: "DesignVariantPolicyV1",
    allowUncertifiedVariants: false,
    allowRawCssInjection: false,
    allowRawJsInjection: false,
});
export const CERTIFIED_LOOKS = [
    CertifiedLookV1Schema.parse({
        schemaVersion: "certified-look.v1.0",
        lookId: "flat-2-default",
        displayName: "Flat 2 Default",
        certified: true,
        accessibilityChecked: true,
        mobileChecked: true,
    }),
];
export function assertCertifiedDesignSelection(selection) {
    const look = CERTIFIED_LOOKS.find((l) => l.lookId === selection.certifiedLookId);
    if (!look?.certified) {
        throw new Error(`Uncertified look blocked: ${selection.certifiedLookId}`);
    }
}
//# sourceMappingURL=design-variety.js.map